/**
 * Created by omero on 26-Jan-17.
 */
import 'ng-infinite-scroll';
import 'angular-inview';
import { NgModule } from 'ng-metadata/core';
import {PrmBrowseSearch} from "./browseSearch.directive";
import {BrowseSearchService} from "./browseSearch.service";
import {PrmBrowseSearchBar} from "./browseSearchBar/browseSearchBar.directive";
import {BrowseSearchBarService} from "./browseSearchBar/browseSearchBar.service";
import {PrmBrowseResult} from "./browseResult/browseResult.directive";
import {BrowseResultService} from "./browseResult/browseResult.service";
import {ScrollService} from "../scroller/scroll.service";
import {PrmScroll} from "../scroller/scroll.directive";

@NgModule({
    declarations: [ PrmBrowseSearch,
                    PrmBrowseSearchBar,
                    PrmBrowseResult,
                PrmScroll
                    ],
    providers: [BrowseSearchService,
                BrowseSearchBarService,
                BrowseResultService,
        ScrollService
                ],
    imports:[
    ]
})
export class BrowseSearchModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/browse/browseSearch.module.ts